import React from "react";
import { Stack, Text } from "@bookingcom/bui-react";
import { t, useI18n } from "@bookingcom/lingojs-react";
import Frame from "../Frame/index.js";
import styles from "./SummerDealBanner.module.css";
import { SUMMER_DEAL_2026_BG_COLOR, SUMMER_DEAL_2026_IMAGE_URL_INDEX_MDOT } from "../../../constants.js";
const SummerDealBanner = () => {
    const i18n = useI18n();
    return (React.createElement(Frame, { attributes: { style: { width: "100%" } }, grow: 1 },
        React.createElement(Stack, { direction: "column", justifyContent: "center", alignItems: "start", className: styles.container, attributes: {
                style: {
                    background: `linear-gradient(90deg, rgba(0, 0, 0, 0.80) 45.19%, rgba(0, 0, 0, 0.00) 100%), url(${SUMMER_DEAL_2026_IMAGE_URL_INDEX_MDOT}) ${SUMMER_DEAL_2026_BG_COLOR}`,
                    backgroundSize: "100% auto",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat"
                }
            } },
            React.createElement(Text, { color: "white", variant: "strong_2", tagName: "strong", attributes: { style: { maxWidth: "80%" } } }, i18n.trans(t("flights_mdot_cat_summer26_index_header"))),
            React.createElement(Text, { color: "white", variant: "body_2", attributes: { style: { maxWidth: "80%" } } }, i18n.trans(t("flights_mdot_cat_summer26_subheader"))))));
};
export default SummerDealBanner;
